import { ChangeDetectionStrategy, Component, effect, HostListener, inject, OnInit, signal } from '@angular/core'
import { BreadcrumbService } from '@ui-core/services/breadcrum.service'
import { MobileService } from '@ui-core/services/mobile.service'
import { UserService } from '@ui-core/services/user.service'
import { ButtonModule } from 'primeng/button'
import { MenuModule } from 'primeng/menu'
import { MenubarModule } from 'primeng/menubar'
import { Logo } from './components/logo/logo'
import { Menu } from './components/menu/menu'

@Component({
    selector: 'app-header',
    imports: [ButtonModule, MenubarModule, MenuModule, Menu, Logo],
    templateUrl: './header.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Header implements OnInit {
    private mobileService = inject(MobileService)
    private userService = inject(UserService)
    private breadcrumbService = inject(BreadcrumbService)

    mobileWidthThreshold = signal(768)
    resizeTimeout = signal<ReturnType<typeof setTimeout> | undefined>(undefined)
    logoLight = signal<string | null>(null)
    logoDark = signal<string | null>(null)
    title = signal<string>('')
    subtitle = signal<string | null>(null)

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        clearTimeout(this.resizeTimeout())
        this.resizeTimeout.set(setTimeout(() => this.checkWindowSize(), 100))
    }

    constructor() {
        this.checkUserLogo()
        this.checkBreadcrumb()
    }

    checkUserLogo(): void {
        const logoLight = this.userService.logoLight()()
        if (logoLight) {
            this.logoLight.set(logoLight)
        }

        const logoDark = this.userService.logoDark()()
        if (logoDark) {
            this.logoDark.set(logoDark)
        }
    }

    checkBreadcrumb(): void {
        effect(() => {
            const title = this.breadcrumbService.title()
            const subtitle = this.breadcrumbService.subtitle()

            if (title !== null && title !== '') {
                this.title.set(title)
                this.subtitle.set(subtitle)
            }
        })
    }

    ngOnInit(): void {
        this.checkWindowSize()
    }

    checkWindowSize(): void {
        const isMobile = window.innerWidth <= this.mobileWidthThreshold()
        this.mobileService.set(isMobile)
    }

    toggleMenu(): void {
        this.mobileService.setIsMobileMenuOpen(!this.mobileService.isMobileMenuOpen()())
    }
}
